<template>
<div>
    <!-- Gerar Pep Arquivos -->
    <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content" v-if="id_paciente">
                <div class="modal-header">
                    <h5 class="modal-title">Baixar Arquivos Assinados do PEP</h5>
                    <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="alert alert-info" role="alert">
                        Insira o e-mail para o qual deseja enviar os arquivos assinados do PEP.
                    </div>

                    <az-input
                        label="E-mail de Destino"
                        type="email"
                        v-model="email"
                        :required="true"
                        :validate="validate">
                    </az-input>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="fechar_modal()">Cancelar</button>
                    <az-submit @click="atualizar()">Processar e Enviar</az-submit>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            id_paciente: null, 
            paciente: null, 
            email: "", 
            validate: false, 
            chave: "", 
        }
    },

    components: { 
        AzInput,
        AzSubmit
    },

    computed: { 
        modal_name: function() { 
            return 'gerarPepArquivosModal' + this.chave;
        }
    },

    methods: { 
        fechar_modal() { 
            $('#' + this.modal_name).modal('hide');
        },

        abrir(id_paciente) { 
            this.id_paciente = id_paciente;
            this.email = ""; 
            this.validate = false; 

            $('#' + this.modal_name).modal('show');
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'pep',
                func: 'gerar_pep_arquivos', 
                dados: { 
                    id_paciente: this.id_paciente,
                    email: this.email
                },
                modal: this.modal_name, 
                toast: true, 
            });
        }
    },

    mounted() { 
        this.chave = this.$util.uuidv4(); 
    }
}
</script>
